import React, { useMemo } from "react";
import dayjs from "dayjs";

const WEEKDAY_LABELS = ["пн", "вт", "ср", "чт", "пт", "сб", "вс"];

/** Понедельник недели (weekStart = 1). */
const startOfWeekMon = (d) => {
  const day = d.startOf("day");
  // dayjs: 0=вс … 6=сб; при weekStart=1 day() тоже 0=вс
  const weekday = day.day(); // 0 Sun … 6 Sat
  const offset = weekday === 0 ? 6 : weekday - 1;
  return day.subtract(offset, "day");
};

/**
 * Недели, пересекающиеся с [dateBeg, dateEnd].
 * В каждой неделе дни вне проживания — disabled.
 */
const buildWeeks = (dateBeg, dateEnd) => {
  const beg = dayjs(dateBeg).startOf("day");
  const end = dayjs(dateEnd).startOf("day");
  if (!beg.isValid() || !end.isValid() || end.isBefore(beg, "day")) return [];

  const weeks = [];
  let weekStart = startOfWeekMon(beg);
  const lastWeekStart = startOfWeekMon(end);

  while (!weekStart.isAfter(lastWeekStart, "day")) {
    const days = [];
    for (let i = 0; i < 7; i += 1) {
      const date = weekStart.add(i, "day");
      const key = date.format("YYYY-MM-DD");
      const inStay = !date.isBefore(beg, "day") && !date.isAfter(end, "day");
      days.push({
        key,
        date,
        dayNum: date.date(),
        monthLabel: date.format("MMM"),
        inStay
      });
    }
    weeks.push({ key: weekStart.format("YYYY-MM-DD"), days });
    weekStart = weekStart.add(7, "day");
  }

  return weeks;
};

/**
 * Контрол выбора даты: только недели проживания, строка = неделя с пн.
 */
const ClientAppointmentPlanDaysWeekCalendar = ({
  dateBeg,
  dateEnd,
  selectedDate,
  qtyByDate,
  onSelect
}) => {
  const weeks = useMemo(() => buildWeeks(dateBeg, dateEnd), [dateBeg, dateEnd]);

  if (!weeks.length) {
    return <div className="plan-days-week-cal plan-days-week-cal--empty">Нет дней в периоде</div>;
  }

  return (
    <div className="plan-days-week-cal">
      <div className="plan-days-week-cal__head">
        {WEEKDAY_LABELS.map((label) => (
          <div key={label} className="plan-days-week-cal__weekday">
            {label}
          </div>
        ))}
      </div>
      <div className="plan-days-week-cal__weeks">
        {weeks.map((week) => (
          <div key={week.key} className="plan-days-week-cal__week">
            {week.days.map((day) => {
              const qty = qtyByDate?.get?.(day.key) || 0;
              const selected = day.key === selectedDate;
              const disabled = !day.inStay;
              return (
                <button
                  key={day.key}
                  type="button"
                  className={`plan-days-week-cal__day${
                    disabled ? " plan-days-week-cal__day--disabled" : ""
                  }${selected ? " plan-days-week-cal__day--selected" : ""}${
                    qty > 0 ? " plan-days-week-cal__day--has-qty" : ""
                  }`}
                  disabled={disabled}
                  onClick={() => onSelect?.(day.key)}
                  title={day.date.format("DD.MM.YYYY")}
                >
                  <span className="plan-days-week-cal__day-num">{day.dayNum}</span>
                  <span className="plan-days-week-cal__day-month">{day.monthLabel}</span>
                  {!disabled && qty > 0 ? (
                    <span className="plan-days-week-cal__day-qty">{qty}</span>
                  ) : null}
                </button>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ClientAppointmentPlanDaysWeekCalendar;
